module.exports = __webpack_public_path__ + "static/media/logo.041cd791.png";